import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import warning from '../../assets/images/backoffice/warning.png';
import warning2 from '../../assets/images/backoffice/warning2.png';
import warning3 from '../../assets/images/backoffice/warning3.png';
import { dateDifferenceInDaysFromToday } from '../../helpers/helperFunctions';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import { CaptionText, P1, P2 } from '../../styles/FontStyles';
import { Box, Button, Flexed } from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';

import { IconTitleStyled } from './DashboardStyled';
import { useAppSelector } from '../../app/hooks';

export const SubscriptionWarning = () => {
  const { t } = useTranslation('dashboard');
  const history = useHistory();

  const { dashboardInfo } = useAppSelector((state) => state.dashboard);

  const date = dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd;

  const dateEnded = dateDifferenceInDaysFromToday(date) === 0;

  const dateEndsIn14 = dateDifferenceInDaysFromToday(date) <= 13;

  return (
    <>
      {dashboardInfo?.user && date ? (
        <>
          {dateEnded ? (
            <>
              <Box p='40px'>
                <Flexed between center>
                  <Flexed column widthSM='100%'>
                    <img
                      src={warning2}
                      style={{
                        maxWidth: 350,
                        width: '100%',
                        marginBottom: 24,
                        marginTop: 10
                      }}
                    />

                    <P2 mb='24'>
                      <b>{t('notifications.message')}</b>
                    </P2>

                    <P2 mb='32'>&#x274C; Full Bonuses ( Direct Bonus) </P2>
                    <Flexed mobile column pointer center width='100%' mb='20'>
                      <img src={warning3} style={{ width: 180 }} />
                      <P1 bold>{t('notifications.trial_ended')}</P1>
                    </Flexed>
                    <Button
                      w='250px'
                      onClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
                      negative>
                      {t('notifications.get_subscription')}
                    </Button>
                  </Flexed>
                  <Flexed desktop column center width='40%'>
                    <img src={warning3} style={{ width: 200 }} />
                    <P1 bold>{t('notifications.trial_ended')}</P1>
                  </Flexed>
                </Flexed>
              </Box>
            </>
          ) : (
            dateEndsIn14 && (
              <>
                <Box p='40px'>
                  <Flexed between center>
                    <Flexed column widthSM='100%'>
                      <CaptionText mb='4' caps bold color={colors.neutral500}>
                        IMPORTANT NOTICE - ACTION REQUIRED
                      </CaptionText>
                      {/* <H4 mb='24'>&#9888; IMPORTANT NOTICE</H4> */}
                      <img src={warning} className='warning-img' />

                      <P2 mb='24'>
                        Without a valid Back-Office subscription{' '}
                        <b>you will STOP RECEIVING:</b>
                      </P2>

                      <P2 mb='32'>&#x274C; Full Bonuses ( Direct Bonus)</P2>

                      <Button
                        w='250px'
                        onClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
                        negative>
                        GET SUBSCRIPTION
                      </Button>
                    </Flexed>
                  </Flexed>
                </Box>
              </>
            )
          )}
        </>
      ) : (
        <>
          <Box p='40px'>
            <Flexed between center>
              <Flexed column widthSM='100%'>
                <CaptionText mb='4' caps bold color={colors.neutral500}>
                  IMPORTANT NOTICE
                </CaptionText>
                <img
                  src={warning2}
                  style={{ width: 350, marginBottom: 24, marginTop: 10 }}
                />

                <P2 mb='24'>
                  <b>You are no longer receiving:</b>
                </P2>

                <P2 mb='32'>Full Bonuses ( Direct Bonus)</P2>
                <Flexed mobile column pointer center width='100%' mb='20'>
                  <img src={warning3} style={{ width: 180 }} />
                  <P1 bold>TRIAL ENDED</P1>
                </Flexed>
                <Button
                  w='250px'
                  onClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
                  negative>
                  GET SUBSCRIPTION
                </Button>
              </Flexed>
              <Flexed desktop column center width='40%'>
                <img src={warning3} style={{ width: 200 }} />
                <P1 bold>TRIAL ENDED</P1>
              </Flexed>
            </Flexed>
          </Box>
        </>
      )}
    </>
  );
};
